import { perms } from '../../jcs';
import { unitoptionsModule } from './index';

function routeConfig($provide, $routeProvider) {
	'ngInject';

	$provide.factory('$routeProvider', () => {
		return $routeProvider;
	});

	// $routeProvider.when(unitoptionsModule.routes.list, {
	// 	controller: unitoptionsModule.controllers.default,
	// 	template: require('./unitoptions.tmpl.html').default,
	// 	activenav: unitoptionsModule.name,
	// 	access: {
	// 		loginRequired: true,
	// 		permissions: [perms['hardware_options.get']],
	// 	},
	// });
}

export default routeConfig;
